import Vue from "vue";
import VueRouter from "vue-router";
import PageNotFound from "@/views/PageNotFound";
import MainComponent from "@/components/MainComponent";
import { getFromLocalStorage } from "@/utils/local-storage.util";
import { USER_ROLE } from "@/enums/user-role.enum";
import AccessDenied from "@/views/AccessDenied";
import LogoutView from "@/views/LogoutView";
import MainWithoutContainerRestrictionsComponent from "@/components/MainWithoutContainerRestrictionsComponent.vue";
import MainComponentWithFullContainer from "@/components/MainComponentWithFullContainer.vue";
import MainAuthLayout from "@/layouts/MainAuthLayout.vue";
import ConnectionsLayer from "@/views/connections/ConnectionsLayer.vue";
import MaterialsLayer from "@/views/materials/MaterialsLayer.vue";
import ExternalLinkView from "@/views/ExternalLinkView.vue";
import PreferencesLayer from "@/views/preferences/PreferencesLayer.vue";
import LessonsLayer from "@/views/lessons/LessonsLayer.vue";
import NotificationsLayer from "@/views/notifications/NotificationsLayer.vue";
import LessonBoardsLayer from "@/views/lesson-boards/LessonBoardsLayer.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: MainWithoutContainerRestrictionsComponent,
    children: [
      {
        path: "",
        name: "main",
        component: () => import("../views/main/MainView.vue"),
      },
      {
        path: "",
        component: MainComponent,
        children: [
          {
            path: "about",
            name: "aboutCommunities",
            component: () => import("../views/main/pages/AboutView.vue"),
          },
          {
            path: "terms-of-service",
            name: "termsOfService",
            component: () =>
              import("../views/main/pages/TermsOfServiceView.vue"),
          },
          {
            path: "privacy-policy",
            name: "privacyPolicy",
            component: () =>
              import("../views/main/pages/PrivacyPolicyView.vue"),
          },
        ],
      },
      {
        path: "",
        component: MainComponentWithFullContainer,
        children: [
          {
            path: "whiteboard-demo",
            name: "whiteboard-demo",
            component: () => import("../views/main/BoardDemoView.vue"),
          },
        ],
      },
    ],
  },
  {
    path: "/",
    component: MainComponent,
    children: [
      {
        path: "",
        component: () => import("../views/main/HomeView.vue"),
        children: [
          // {
          //   path: '',
          //   redirect: 'profile'
          // },
          {
            path: "search",
            name: "search",
            component: () => import("../views/main/SearchView.vue"),
            meta: {
              auth: true,
            },
          },
          // {
          //   path: "profile/:userId(\\d+)",
          //   component: () => import("../layouts/ProfileLayer.vue"),
          //   children: [
          //     {
          //       path: "",
          //       name: "userProfile",
          //       component: () => import("../views/main/profile/MainView.vue"),
          //     },
          //     {
          //       path: "connections",
          //
          //       component: () =>
          //         import("../views/main/profile/NotificationsView.vue"),
          //       meta: {
          //         auth: true,
          //       },
          //     },
          //     {
          //       path: "schedule",
          //       name: "schedule",
          //       component: () =>
          //         import("../views/main/profile/ScheduleView.vue"),
          //     },
          //     {
          //       path: "materials",
          //       component: () => import("../layouts/UserMaterialsLayout.vue"),
          //       children: [
          //         {
          //           path: "",
          //           redirect: () => {
          //             return { name: "lessons" };
          //           },
          //         },
          //         {
          //           path: "lessons/categories/:categoryId(\\d+)?",
          //           name: "lessons",
          //           component: () =>
          //             import(
          //               "../views/main/profile/materials/lesson/NotificationsView.vue"
          //             ),
          //         },
          //         {
          //           path: "quizzes/categories/:categoryId(\\d+)?",
          //           name: "quizzes",
          //           component: () =>
          //             import(
          //               "../views/main/profile/materials/quiz/QuizzesView.vue"
          //             ),
          //         },
          //       ],
          //     },
          //   ],
          // },
          // Self
          // {
          //   path: "profile",
          //   // component: () => import("../layouts/EmptyLayout"),
          //   component: () => import("../layouts/ProfileLayer.vue"),
          //   meta: {
          //     auth: true,
          //   },
          //   children: [
          //     {
          //       path: "",
          //       name: "selfUserProfile",
          //       component: () =>
          //         import("../views/main/my-profile/MainView.vue"),
          //     },
          //     {
          //       path: "feed",
          //       name: "selfUserFeed",
          //       component: () =>
          //         import("../views/main/my-profile/FeedView.vue"),
          //     },
          //     {
          //       path: "preview",
          //       name: "selfUserProfilePreview",
          //       component: () =>
          //         import("../views/main/my-profile/MainPreviewView.vue"),
          //     },
          //     {
          //       path: "schedule",
          //       name: "selfSchedule",
          //       component: () =>
          //         import("../views/main/profile/ScheduleView.vue"),
          //     },
          //     // {
          //     //   path: "notifications",
          //     //   name: "notifications",
          //     //   component: () =>
          //     //     import("../views/main/my-profile/NotificationsView.vue"),
          //     // },
          //     {
          //       path: "connections",
          //       component: () => import("../layouts/EmptyLayout"),
          //       children: [
          //         {
          //           path: "shared-contacts",
          //           name: "selfSharedContacts",
          //           component: () =>
          //             import(
          //               "../views/main/my-profile/connection/SharedContactsView.vue"
          //             ),
          //         },
          //         {
          //           path: "",
          //           name: "selfConnections",
          //           component: () =>
          //             import(
          //               "../views/main/my-profile/connection/ConnectionsView.vue"
          //             ),
          //         },
          //
          //         {
          //           path: "invitations",
          //           name: "selfConnectionInvitations",
          //           component: () =>
          //             import(
          //               "../views/main/my-profile/connection/ConnectionInvitationsView.vue"
          //             ),
          //         },
          //       ],
          //     },
          //     {
          //       path: "materials",
          //       component: () => import("../layouts/UserMaterialsLayout.vue"),
          //       children: [
          //         {
          //           path: "",
          //           name: "selfMaterials",
          //           component: () =>
          //             import(
          //               "../views/main/my-profile/materials/SelfMaterials.vue"
          //             ),
          //         },
          //         // {
          //         //   path: "lessons",
          //         //   component: () =>
          //         //     import(
          //         //       "../views/main/my-profile/materials/lesson/NotificationsView.vue"
          //         //     ),
          //         //   children: [
          //         //     {
          //         //       path: "categories/:categoryId(\\d+)?",
          //         //       name: "selfLessons",
          //         //       component: () =>
          //         //         import(
          //         //           "../views/main/my-profile/materials/lesson/OwnedLessonsView.vue"
          //         //         ),
          //         //     },
          //         //     {
          //         //       path: "saved-categories",
          //         //       component: () => import("../layouts/EmptyLayout.vue"),
          //         //       children: [
          //         //         {
          //         //           path: ":categoryId(\\d+)?",
          //         //           name: "selfSavedLessons",
          //         //           component: () =>
          //         //             import(
          //         //               "../views/main/my-profile/materials/lesson/ForkedLessonsView.vue"
          //         //             ),
          //         //         },
          //         //         {
          //         //           path: ":authorId(\\d+)/:startCategoryId(\\d+)-:categoryId(\\d+)",
          //         //           name: "selfSavedPreviewLessons",
          //         //           component: () =>
          //         //             import(
          //         //               "../views/main/my-profile/materials/lesson/ForkedLessonsView.vue"
          //         //             ),
          //         //         },
          //         //       ],
          //         //     },
          //         //   ],
          //         // },
          //
          //         {
          //           path: "quizzes",
          //           component: () =>
          //             import(
          //               "../views/main/my-profile/materials/quiz/QuizzesView.vue"
          //             ),
          //           children: [
          //             {
          //               path: "categories/:categoryId(\\d+)?",
          //               name: "selfQuizzes",
          //               component: () =>
          //                 import(
          //                   "../views/main/my-profile/materials/quiz/OwnedQuizzesView.vue"
          //                 ),
          //             },
          //             {
          //               path: "saved-categories",
          //               component: () => import("../layouts/EmptyLayout.vue"),
          //               children: [
          //                 {
          //                   path: ":categoryId(\\d+)?",
          //                   name: "selfSavedQuizzes",
          //                   component: () =>
          //                     import(
          //                       "../views/main/my-profile/materials/quiz/ForkedQuizzesView.vue"
          //                     ),
          //                 },
          //                 {
          //                   path: ":authorId(\\d+)/:startCategoryId(\\d+)-:categoryId(\\d+)",
          //                   name: "selfSavedPreviewQuizzes",
          //                   component: () =>
          //                     import(
          //                       "../views/main/my-profile/materials/quiz/ForkedQuizzesView.vue"
          //                     ),
          //                 },
          //               ],
          //             },
          //           ],
          //         },
          //         {
          //           path: "file-manager",
          //           name: "fileManager",
          //           component: () =>
          //             import(
          //               "../views/main/my-profile/materials/FileManager.vue"
          //             ),
          //         },
          //       ],
          //     },
          //   ],
          // },
        ],
      },
    ],
  },
  {
    path: "/",
    component: () => import("../layouts/EmptyLayout.vue"),
    children: [
      {
        path: "live-lesson/:lessonScheduleId",
        name: "liveLesson",
        component: () => import("../views/lessons/LiveLessonView.vue"),
      },
      {
        path: "profile",
        component: () => import("../layouts/EmptyLayout.vue"),
        meta: {
          auth: true,
        },
        children: [
          // {
          //   path: "live-lesson",
          //   component: () => import("../layouts/EmptyLayout.vue"),
          //   children: [
          //     {
          //       path: "",
          //       name: "liveLessons",
          //       component: () =>
          //         import("../views/main/my-profile/live-lesson/LiveLesson.vue"),
          //     },
          //     {
          //       path: ":lessonScheduleId(\\d+)",
          //       name: "liveLesson",
          //       component: () =>
          //         import(
          //           "../views/main/my-profile/live-lesson/LessonSchedule.vue"
          //         ),
          //     },
          //   ],
          // },
        ],
      },
      {
        path: "profile",
        component: () => import("../layouts/EmptyLayout.vue"),
        children: [
          {
            path: "materials",
            component: () => import("../layouts/EmptyLayout.vue"),
            children: [
              {
                path: "lessons/:lessonId(\\d+|new)",
                name: "lessonDetails",
                component: () =>
                  import(
                    "../views/main/profile/materials/lesson/CreateEditPreviewView.vue"
                  ),
              },
              {
                path: "quizzes/:quizId(\\d+|new)",
                name: "quizDetails",
                component: () =>
                  import(
                    "../views/main/profile/materials/quiz/CreateEditPreviewView.vue"
                  ),
              },
            ],
          },
        ],
      },
    ],
  },
  {
    path: "/auth",
    component: () => import("../layouts/AuthLayout.vue"),
    children: [
      {
        path: "sign-in",
        name: "signIn",
        component: () => import("../views/auth/SignInView.vue"),
      },
      {
        path: "sign-up",
        component: () => import("../layouts/EmptyLayout.vue"),
        children: [
          {
            path: "",
            name: "signUp",
            component: () => import("../views/auth/SignUpView.vue"),
          },
          {
            path: "instructor",
            name: "signUpInstructor",
            component: () => import("../views/auth/SignUpInstructorView.vue"),
          },
          {
            path: "student",
            name: "signUpStudent",
            component: () => import("../views/auth/SignUpStudentView.vue"),
          },
        ],
      },
      {
        path: "restore-password",
        name: "restorePassword",
        component: () => import("../views/auth/RestorePasswordView.vue"),
      },
    ],
  },
  {
    path: "/",
    component: MainAuthLayout,
    meta: {
      auth: true,
    },
    children: [
      {
        path: "feed",
        name: "feed",
        component: () => import("../views/FeedView.vue"),
      },
      {
        path: "connections",
        component: ConnectionsLayer,
        children: [
          {
            path: "",
            name: "connections",
            component: () => import("../views/connections/ConnectionsView.vue"),
          },
          {
            path: "list",
            name: "connectionsList",
            component: () =>
              import("../views/connections/ConnectionsListView.vue"),
          },
          {
            path: "pending-invitations",
            name: "connectionInvitations",
            component: () =>
              import("../views/connections/ConnectionInvitationsView.vue"),
          },
          {
            path: "shared-contacts",
            name: "connectionSharedContacts",
            component: () =>
              import("../views/connections/SharedContactsView.vue"),
          },
        ],
      },
      {
        path: "lessons",
        component: LessonsLayer,
        children: [
          {
            path: "",
            name: "lessons",
            component: () => import("../views/lessons/LessonsView.vue"),
          },
          {
            path: "upcoming",
            name: "upcomingLessons",
            component: () => import("../views/lessons/UpcomingLessonsView.vue"),
          },
          {
            path: "past",
            name: "pastLessons",
            component: () => import("../views/lessons/PastLessonsView.vue"),
          },
          // {
          //   path: "upcoming",
          //   name: "connectionsList",
          //   component: () =>
          //     import("../views/connections/ConnectionsListView.vue"),
          // },
          // {
          //   path: "pending-invitations",
          //   name: "connectionInvitations",
          //   component: () =>
          //     import("../views/connections/ConnectionInvitationsView.vue"),
          // },
          // {
          //   path: "shared-contacts",
          //   name: "connectionSharedContacts",
          //   component: () =>
          //     import("../views/connections/SharedContactsView.vue"),
          // },
        ],
      },
      {
        path: "notifications",
        component: NotificationsLayer,
        children: [
          {
            path: "",
            name: "notifications",
            component: () =>
              import("../views/notifications/NotificationsView.vue"),
          },
          {
            path: ":type",
            name: "categorizedNotifications",
            component: () =>
              import("../views/notifications/CategorizedNotificationsView.vue"),
          },
        ],
      },
      {
        path: "preferences",
        component: PreferencesLayer,
        children: [
          {
            path: "",
            name: "preferences",
            component: () => import("../views/preferences/PreferencesView.vue"),
          },
          {
            path: "account",
            component: () => import("../layouts/EmptyLayout.vue"),
            children: [
              {
                path: "",
                name: "account-preferences",
                component: () =>
                  import(
                    "../views/preferences/account/AccountPreferencesView.vue"
                  ),
              },
              {
                path: "name",
                name: "account-name-preferences",
                component: () =>
                  import(
                    "../views/preferences/account/AccountPreferencesNameView.vue"
                  ),
              },
              {
                path: "contact",
                name: "account-contact-preferences",
                component: () =>
                  import(
                    "../views/preferences/account/AccountPreferencesContactView.vue"
                  ),
              },
              {
                path: "headline",
                name: "account-headline-preferences",
                component: () =>
                  import(
                    "../views/preferences/account/AccountPreferencesHeadlineView.vue"
                  ),
              },
              {
                path: "about",
                name: "account-about-preferences",
                component: () =>
                  import(
                    "../views/preferences/account/AccountPreferencesAboutView.vue"
                  ),
              },
              {
                path: "specialities",
                name: "account-specialities-preferences",
                component: () =>
                  import(
                    "../views/preferences/account/AccountPreferencesSpecialitiesView.vue"
                  ),
              },
              {
                path: "target-language",
                name: "account-target-language-preferences",
                component: () =>
                  import(
                    "../views/preferences/account/AccountPreferencesTargetLanguageView.vue"
                  ),
              },
              {
                path: "speak-language",
                name: "account-speak-language-preferences",
                component: () =>
                  import(
                    "../views/preferences/account/AccountPreferencesSpeakLanguagesView.vue"
                  ),
              },
            ],
          },
          {
            path: "security",
            component: () => import("../layouts/EmptyLayout.vue"),
            children: [
              {
                path: "",
                name: "sign-in-and-security-preferences",
                component: () =>
                  import(
                    "../views/preferences/sign-in-and-security/SignInSecurityPreferencesView.vue"
                  ),
              },
              {
                path: "change-email",
                name: "account-change-email-preferences",
                component: () =>
                  import(
                    "../views/preferences/sign-in-and-security/SignInAndSecurityPreferencesChangeEmailView.vue"
                  ),
              },
              {
                path: "change-password",
                name: "account-change-password-preferences",
                component: () =>
                  import(
                    "../views/preferences/sign-in-and-security/SignInAndSecurityPreferencesPasswordView.vue"
                  ),
              },
            ],
          },
        ],
      },
      {
        path: "messages",
        component: () => import("../views/messages/MessagesView"),
        meta: {
          mainContainerClass: "fill-height",
        },
        children: [
          {
            path: "",
            name: "messages",
            component: () =>
              import("../views/messages/MessagesEmptyChatView.vue"),
          },
          {
            path: ":id",
            name: "messageChat",
            component: () => import("../views/messages/MessagesChatView.vue"),
          },
        ],
      },
      {
        path: "materials",
        component: MaterialsLayer,
        children: [
          {
            path: "",
            name: "materials",
            component: () => import("../views/materials/MaterialsView.vue"),
          },
          {
            path: "common",
            name: "common-publications-list",
            component: () =>
              import(
                "../views/materials/publications/CommonPublicationsListView.vue"
              ),
          },
          {
            path: "owned",
            component: () => import("../layouts/EmptyLayout.vue"),
            children: [
              {
                path: "",
                name: "owned-publications-list",
                component: () =>
                  import(
                    "../views/materials/publications/OwnedPublicationsListView.vue"
                  ),
              },
              {
                path: "my",
                name: "owned-my-publications-list",
                component: () =>
                  import(
                    "../views/materials/publications/OwnedMyPublicationsListView.vue"
                  ),
              },
              {
                path: "saved",
                name: "owned-saved-publications-list",
                component: () =>
                  import(
                    "../views/materials/publications/OwnedSavedPublicationsListView.vue"
                  ),
              },
            ],
          },
        ],
      },
      {
        path: "materials",
        component: () => import("../layouts/EmptyLayout.vue"),
        children: [
          {
            path: "new",
            name: "new-publication",
            component: () =>
              import(
                "../views/materials/publications/CreatePublicationView.vue"
              ),
          },
          {
            path: "edit/:id(\\d+)",
            name: "edit-publication",
            component: () =>
              import("../views/materials/publications/EditPublicationView.vue"),
          },
          {
            path: ":id(\\d+)",
            name: "view-publication",
            component: () =>
              import("../views/materials/publications/ViewPublicationView.vue"),
          },
        ],
      },
      {
        path: "lesson-boards",
        component: () => import("../layouts/EmptyLayout.vue"),
        children: [
          {
            path: "",
            component: LessonBoardsLayer,
            children: [
              {
                path: "",
                name: "lesson-boards",
                component: () =>
                  import("../views/lesson-boards/LessonBoardsView.vue"),
              },
            ],
          },
          {
            path: ":id(\\d+)",
            name: "edit-lesson-board",
            meta: {
              mainContainerClass: "fill-height",
            },
            component: () =>
              import("../views/lesson-boards/EditLessonBoardView.vue"),
          },
        ],
      },
    ],
  },
  {
    path: "/",
    component: MainAuthLayout,
    children: [
      {
        name: "skill",
        path: "skills/:skill",
        component: () => import("../views/SkillView.vue"),
      },
      {
        path: "feed/update/post/:id",
        name: "view-post",
        component: () => import("../views/feed/FeedItemView.vue"),
      },
      {
        path: "profile/:userId(\\d+)",
        component: () => import("../views/profile/ProfileLayer.vue"),
        children: [
          {
            path: "",
            name: "userProfile",
            component: () => import("../views/profile/ProfileView.vue"),
          },
          {
            path: "details",
            component: () => import("../layouts/DeepProfileLayout.vue"),
            children: [
              {
                path: "certificates",
                name: "userProfileDetailsCertificates",
                component: () =>
                  import(
                    "../views/profile/details/ProfileDetailsCertificatesView.vue"
                  ),
              },
              {
                path: "connections",
                name: "userProfileDetailsConnections",
                component: () =>
                  import(
                    "../views/profile/details/ProfileDetailsConnectionsView.vue"
                  ),
              },
              {
                path: "instructors",
                name: "userProfileDetailsInstructors",
                component: () =>
                  import(
                    "../views/profile/details/ProfileDetailsInstructorsView.vue"
                  ),
              },
              {
                path: "students",
                name: "userProfileDetailsStudents",
                component: () =>
                  import(
                    "../views/profile/details/ProfileDetailsStudentsView.vue"
                  ),
              },
              {
                path: "reviews",
                name: "userProfileDetailsReviews",
                component: () =>
                  import(
                    "../views/profile/details/ProfileDetailsReviewsView.vue"
                  ),
              },
            ],
          },
        ],
      },
    ],
  },

  {
    path: "/external-link",
    name: "externalLink",
    component: ExternalLinkView,
  },

  {
    path: "/logout",
    name: "logout",
    component: LogoutView,
  },
  {
    path: "/access-denied",
    component: AccessDenied,
  },
  {
    path: "*",
    component: PageNotFound,
  },
  {
    path: "/lesson-board/:lessonBoardId/preview",
    name: "lesson-board-preview",
    component: () => import("../views/BoardPreviewView.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

let previousRoute = null;
// check redirect role,permission
router.beforeEach(async (to, from, next) => {
  previousRoute = from;
  const isLoggedIn = getFromLocalStorage("accessToken");
  if (to.matched.some((m) => m.meta.auth) && !isLoggedIn) {
    return next({
      name: "signIn",
      query: {
        redirectAfter: to.path,
      },
    });
  }

  const tmpUser = getFromLocalStorage("user");
  if (isLoggedIn && tmpUser) {
    const user = JSON.parse(tmpUser);
    if (
      user.role !== USER_ROLE.ADMIN &&
      !to.matched
        .filter((m) => m.meta.permissions && m.meta.permissions.length)
        .every((m) => m.meta.permissions.includes(user.role))
    ) {
      return next({
        path: "/access-denied",
        query: {
          redirectAfter: from.path,
        },
      });
    }
  }

  // end check router prior with permission, role
  return next();
});

Vue.prototype.$previousRoute = () => previousRoute;
export default router;
